module.exports = __webpack_public_path__ + "img/learner-quiz-Competitor.b670c1e3.png";